<label [attr.for]="forElement"><ng-content></ng-content></label>
